import useNotification from 'hooks/API/GET/useNotification';
import useManageNotification from 'hooks/API/useManageNotification';
import useToaster from 'hooks/useToaster';
import { useParams } from 'react-router-dom';
import NotificationManageSection from './NotificationManageSection';
import { notifier } from 'components/Toaster';

function ManageNotification() {
  const { isLoading, mutate, isError } = useManageNotification();
  const { notificationId } = useParams();

  // useToaster(isLoading, { type: isError ? 'error' : 'success' });

  const { data } = useNotification({
    enabled: notificationId !== 'add',
    notificationId,
  });

  function handleNotification(notificationFormData = {}) {
    if (isLoading) return;

    mutate(
      {
        data: notificationFormData,
        notificationId: notificationId !== 'add' ? notificationId : null,
      },
      {
        onSuccess: (data) => {
          console.log('🚀 ~ handleNotification ~ data:', data);
          notifier.success(data?.data?.data?.message);
        },
        onError: (err) => {
          notifier.error(err.response.data.message);
        },
      }
    );
  }

  return (
    <div className="mainWraper">
      <div className="container-fluid">
        <NotificationManageSection
          handleNotification={handleNotification}
          preloadedData={data?.data ?? {}}
        />
      </div>
    </div>
  );
}

export default ManageNotification;
